import { withInstall } from '@klondpay/utils';
import popup from './src/index.vue';
export const Popup = withInstall(popup);
export default Popup;
